import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Avatar,
  CircularProgress,
  Typography,
} from "@material-ui/core";
import api from "../../services/api";
import toastError from "../../errors/toastError";

// feat_232/233: selector de usuario para impersonar. Por defecto lista users
// no-admin (users-brief); con `endpoint="admins-brief"` lista admins (feat_233,
// cuando una empresa tiene >1 admin). `title` es opcional.
const UserSelectorModal = ({
  open,
  company,
  onClose,
  onImpersonate,
  endpoint = "users-brief",
  title,
}) => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!open || !company) return;
    let active = true;
    (async () => {
      setLoading(true);
      try {
        const { data } = await api.get(
          `/superadmin/companies/${company.id}/${endpoint}`
        );
        if (active) setUsers(data || []);
      } catch (err) {
        toastError(err);
      } finally {
        if (active) setLoading(false);
      }
    })();
    return () => {
      active = false;
    };
  }, [open, company, endpoint]);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>{title || `Ver como usuario — ${company?.name}`}</DialogTitle>
      <DialogContent>
        {loading ? (
          <CircularProgress size={22} />
        ) : users.length === 0 ? (
          <Typography variant="body2" color="textSecondary">
            Sin usuarios no-admin en esta empresa.
          </Typography>
        ) : (
          <List>
            {users.map((u) => (
              <ListItem button key={u.id} onClick={() => onImpersonate(u.id)}>
                <ListItemAvatar>
                  <Avatar>{(u.name || "?")[0].toUpperCase()}</Avatar>
                </ListItemAvatar>
                <ListItemText primary={u.name} secondary={u.email} />
              </ListItem>
            ))}
          </List>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancelar</Button>
      </DialogActions>
    </Dialog>
  );
};

export default UserSelectorModal;
